import {
  GetBriefingsRequest,
  BriefingsResponse,
  BriefingDetailResponse,
  CreateBriefingRequest,
  CreateBriefingResponse,
  UpdateBriefingRequest,
  UpdateBriefingResponse,
} from '@/types/briefings';
import { api } from './index';

class BriefingsService {
  /**
   * Get all briefings
   * GET /v3/briefings/
   */
  async getBriefings(params?: GetBriefingsRequest): Promise<BriefingsResponse> {
    try {
      const response = await api.get<BriefingsResponse>('/briefings/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching briefings:', error);
      throw error;
    }
  }

  /**
   * Get briefing by ID
   * GET /v3/briefings/{briefing_id}
   */
  async getBriefingById(briefingId: string): Promise<BriefingDetailResponse> {
    try {
      const response = await api.get<BriefingDetailResponse>(`/briefings/${briefingId}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching briefing ${briefingId}:`, error);
      throw error;
    }
  }

  /**
   * Create a new briefing
   * POST /v3/briefings/
   */
  async createBriefing(request: CreateBriefingRequest): Promise<CreateBriefingResponse> {
    try {
      const response = await api.post<CreateBriefingResponse>('/briefings/', request);
      return response.data;
    } catch (error) {
      console.error('Error creating briefing:', error);
      throw error;
    }
  }

  /**
   * Update an existing briefing
   * PATCH /v3/briefings/{briefing_id}
   */
  async updateBriefing(request: UpdateBriefingRequest): Promise<UpdateBriefingResponse> {
    try {
      const { briefing_id, ...payload } = request;
      const response = await api.patch<UpdateBriefingResponse>(
        `/briefings/${briefing_id}`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error('Error updating briefing:', error);
      throw error;
    }
  }
}

export const briefingsService = new BriefingsService();
